import { motion } from "framer-motion";

// Paste the configuration generated from the Logo Editor here!
const CONFIG = {
  "baseClip": "polygon(0% 58%, 100% 58%, 100% 100%, 0% 100%)",
  "spokeClip": "polygon(45% 6%, 56% 6%, 56% 30%, 45% 30%)",
  "spokes": [
    { "x": 51, "y": 50, "rotation": -90, "scale": 1 },
    { "x": 51, "y": 50, "rotation": -60, "scale": 1 },
    { "x": 50, "y": 50, "rotation": -30, "scale": 1 },
    { "x": 50, "y": 50, "rotation": 0, "scale": 1 },
    { "x": 50, "y": 50, "rotation": 29, "scale": 1 },
    { "x": 50, "y": 50, "rotation": 58, "scale": 1 },
    { "x": 50, "y": 48, "rotation": 92, "scale": 1 }
  ]
};

export default function LoadingScreen() {
  const logoSrc = "/logo_transparent.png";

  return (
    <motion.div
      initial={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
      className="fixed inset-0 z-[100] flex items-center justify-center bg-[var(--color-bg)] backdrop-blur-sm"
    >
      <div className="relative w-32 h-32 md:w-48 md:h-48 drop-shadow-[0_0_12px_var(--color-coral-glow)]">
        
        {/* Base (Hands and center) */}
        <motion.img 
          src={logoSrc} 
          alt="WellMed Logo Base"
          className="absolute inset-0 w-full h-full object-contain"
          style={{ clipPath: CONFIG.baseClip }}
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, ease: "easeOut" }}
        />

        {/* Spokes */}
        {CONFIG.spokes.map((spoke, i) => (
          <motion.div
            key={i}
            className="absolute inset-0 w-full h-full"
            style={{
              left: `${spoke.x - 50}%`,
              top: `${spoke.y - 50}%`,
              transformOrigin: "center"
            }}
            initial={{ opacity: 0, scale: 0.5, rotate: spoke.rotation }}
            animate={{ opacity: 1, scale: spoke.scale, rotate: spoke.rotation }}
            transition={{ duration: 0.4, delay: 0.6 + (i * 0.15), ease: "easeOut" }}
          >
            <img 
              src={logoSrc}
              alt={`Spoke ${i + 1}`}
              className="absolute inset-0 w-full h-full object-contain"
              style={{ clipPath: CONFIG.spokeClip }}
            />
          </motion.div>
        ))}

      </div>
    </motion.div>
  );
}
